(function () {
  'use strict';

  var campaignKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'fbclid'
  ];
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var adKeys = ['gclid', 'fbclid'];
  var campaignStorageKey = 'cantina_campaign_params_v2';
  var eventFormPendingKey = 'cantina_event_form_pending_v2';
  var eventFormCompletedKey = 'cantina_event_form_completed_v2';
  var cookiePreferencesBound = false;
  var cookiePreferencesObserverBound = false;
  var nativeCookiePreferencesBound = false;
  var visitorConsentBound = false;

  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  window.dataLayer = window.dataLayer || [];

  function isAllowedKey(key) {
    return campaignKeys.indexOf(key) !== -1;
  }

  function isUtmKey(key) {
    return utmKeys.indexOf(key) !== -1;
  }

  function isAdKey(key) {
    return adKeys.indexOf(key) !== -1;
  }

  function readStoredCampaignParams() {
    try {
      var raw = window.sessionStorage.getItem(campaignStorageKey);
      var parsed = raw ? JSON.parse(raw) : {};
      return typeof parsed === 'object' && parsed ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeStoredCampaignParams(params) {
    try {
      if (Object.keys(params).length) {
        window.sessionStorage.setItem(campaignStorageKey, JSON.stringify(params));
      } else {
        window.sessionStorage.removeItem(campaignStorageKey);
      }
    } catch (error) {
      return;
    }
  }

  function readCurrentCampaignParams() {
    var params = {};
    var searchParams = new URLSearchParams(window.location.search);

    campaignKeys.forEach(function (key) {
      var value = searchParams.get(key);
      if (value) params[key] = value;
    });

    return params;
  }

  function getConsentState() {
    var state = {
      apiAvailable: false,
      analyticsAllowed: false,
      marketingAllowed: false,
      preferencesAllowed: false
    };
    var privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy) return state;

    state.apiAvailable = true;
    state.analyticsAllowed =
      typeof privacy.analyticsProcessingAllowed === 'function' && !!privacy.analyticsProcessingAllowed();
    state.marketingAllowed =
      typeof privacy.marketingAllowed === 'function' && !!privacy.marketingAllowed();
    state.preferencesAllowed =
      typeof privacy.preferencesProcessingAllowed === 'function' && !!privacy.preferencesProcessingAllowed();

    return state;
  }

  function filterPersistedCampaignParams(params, consentState) {
    var filtered = {};

    Object.keys(params).forEach(function (key) {
      if (!isAllowedKey(key) || !params[key]) return;

      if (isUtmKey(key) && (consentState.analyticsAllowed || consentState.marketingAllowed)) {
        filtered[key] = params[key];
      }

      if (isAdKey(key) && consentState.marketingAllowed) {
        filtered[key] = params[key];
      }
    });

    return filtered;
  }

  function updateStoredCampaignParams() {
    var currentParams = readCurrentCampaignParams();
    var consentState = getConsentState();
    var nextParams = filterPersistedCampaignParams(readStoredCampaignParams(), consentState);

    Object.keys(currentParams).forEach(function (key) {
      if (isUtmKey(key) && (consentState.analyticsAllowed || consentState.marketingAllowed)) {
        nextParams[key] = currentParams[key];
      }

      if (isAdKey(key) && consentState.marketingAllowed) {
        nextParams[key] = currentParams[key];
      }
    });

    writeStoredCampaignParams(nextParams);
  }

  function buildOutboundCampaignParams() {
    var consentState = getConsentState();
    var outbound = filterPersistedCampaignParams(readStoredCampaignParams(), consentState);
    var currentParams = readCurrentCampaignParams();

    Object.keys(currentParams).forEach(function (key) {
      if (isAllowedKey(key) && currentParams[key]) {
        outbound[key] = currentParams[key];
      }
    });

    return outbound;
  }

  function updatePlateformLinks() {
    var outboundParams = buildOutboundCampaignParams();

    Array.prototype.forEach.call(document.querySelectorAll('a[href]'), function (link) {
      var url;

      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.hostname !== 'cantinaantica.plateform.app') return;

      Object.keys(outboundParams).forEach(function (key) {
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, outboundParams[key]);
        }
      });

      link.href = url.toString();
    });
  }

  function pushDataLayerEvent(name, destination, text, location) {
    window.dataLayer.push({
      event: name,
      link_url: destination || '',
      link_text: text || '',
      page_path: window.location.pathname,
      cta_location: location || ''
    });
  }

  function bindTrackedClicks() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-track]');
      if (!trigger) return;

      pushDataLayerEvent(
        trigger.dataset.track,
        trigger.getAttribute('href') || '',
        (trigger.textContent || '').trim(),
        trigger.dataset.trackLocation || ''
      );
    });
  }

  function bindMobileNavigation() {
    Array.prototype.forEach.call(document.querySelectorAll('.mobile-nav a'), function (link) {
      link.addEventListener('click', function () {
        var menu = link.closest('details');
        if (menu) menu.removeAttribute('open');
      });
    });
  }

  function getCookiePreferencesHandler() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      return function () {
        window.privacyBanner.showPreferences();
      };
    }

    return null;
  }

  function wireCookiePreferencesButton() {
    var cookieButton = document.querySelector('[data-cookie-preferences]');
    var handler = cookieButton ? getCookiePreferencesHandler() : null;

    if (!cookieButton) return;

    if (!handler) {
      cookieButton.hidden = true;
      return;
    }

    cookieButton.hidden = false;

    if (cookiePreferencesBound) return;

    cookiePreferencesBound = true;
    cookieButton.addEventListener('click', function () {
      var liveHandler = getCookiePreferencesHandler();
      if (!liveHandler) {
        wireCookiePreferencesButton();
        return;
      }

      liveHandler();
    });
  }

  function wireNativeCookiePreferencesButton() {
    var nativeButton = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    var handler = nativeButton ? getCookiePreferencesHandler() : null;

    if (!nativeButton || !handler || nativeCookiePreferencesBound) return;

    nativeCookiePreferencesBound = true;
    nativeButton.addEventListener('click', function (event) {
      event.preventDefault();
      handler();
    });
  }

  function observeCookieControls() {
    if (cookiePreferencesObserverBound || !window.MutationObserver) return;

    cookiePreferencesObserverBound = true;

    var observer = new MutationObserver(function () {
      wireNativeCookiePreferencesButton();
      wireCookiePreferencesButton();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'style', 'open']
    });

    [250, 1000, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        wireNativeCookiePreferencesButton();
        wireCookiePreferencesButton();
      }, delay);
    });
  }

  function bindVisitorConsentListener() {
    if (visitorConsentBound) return;

    visitorConsentBound = true;
    document.addEventListener('visitorConsentCollected', function () {
      updateStoredCampaignParams();
      updatePlateformLinks();
      wireNativeCookiePreferencesButton();
      wireCookiePreferencesButton();
    });
  }

  function initializePrivacyApi(onReady) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      onReady();
      return;
    }

    if (
      window.Shopify &&
      typeof window.Shopify.loadFeatures === 'function'
    ) {
      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1'
          }
        ],
        function () {
          onReady();
        }
      );
      return;
    }

    onReady();
  }

  function setupEventForm() {
    var eventForm = document.getElementById('EventContactForm');
    var successMessage = document.querySelector('.form-success');

    if (successMessage) {
      try {
        if (
          window.sessionStorage.getItem(eventFormPendingKey) &&
          window.sessionStorage.getItem(eventFormCompletedKey) !== window.location.pathname
        ) {
          pushDataLayerEvent(
            'event_request_complete',
            window.location.pathname,
            successMessage.textContent.trim()
          );
          window.sessionStorage.removeItem(eventFormPendingKey);
          window.sessionStorage.setItem(eventFormCompletedKey, window.location.pathname);
        }
      } catch (error) {
        return;
      }
    }

    if (!eventForm) return;

    eventForm.addEventListener('submit', function () {
      if (!eventForm.checkValidity()) return;
      if (eventForm.getAttribute('data-cantina-submitting') === 'true') return;

      eventForm.setAttribute('data-cantina-submitting', 'true');

      try {
        window.sessionStorage.setItem(eventFormPendingKey, String(Date.now()));
      } catch (error) {
        return;
      }

      pushDataLayerEvent(
        'submit_event_request',
        eventForm.getAttribute('action') || window.location.pathname,
        'Invia la richiesta'
      );
    });
  }

  bindTrackedClicks();
  bindMobileNavigation();
  setupEventForm();
  initializePrivacyApi(function () {
    updateStoredCampaignParams();
    updatePlateformLinks();
    wireNativeCookiePreferencesButton();
    wireCookiePreferencesButton();
    observeCookieControls();
    bindVisitorConsentListener();
  });
})();
